module.exports = __webpack_public_path__ + "img/family-4.74bcd9fb.jpg";